import { FormEvent } from 'react';
import { CalendarServiceType } from '../../types/calendar';
import { Form, FormField, FormLabel, FormInput, FormTextarea, Button } from '../ui';

interface ServiceTypeFormProps {
  serviceType: CalendarServiceType | null;
  onSubmit: (e: FormEvent<HTMLFormElement>) => void;
  isLoading: boolean;
  onClose: () => void;
}

function ServiceTypeForm({ serviceType, onSubmit, isLoading, onClose }: ServiceTypeFormProps) {
  return (
    <Form onSubmit={onSubmit}>
      <FormField>
        <FormLabel htmlFor="name" required>
          Nome
        </FormLabel>
        <FormInput id="name" name="name" defaultValue={serviceType?.name} required />
      </FormField>

      <FormField>
        <FormLabel htmlFor="description">Descrição</FormLabel>
        <FormTextarea
          id="description"
          name="description"
          defaultValue={serviceType?.description}
          rows={3}
        />
      </FormField>

      <FormField>
        <FormLabel htmlFor="duration_minutes" required>
          Duração (minutos)
        </FormLabel>
        <FormInput
          id="duration_minutes"
          name="duration_minutes"
          type="number"
          min="5"
          step="5"
          defaultValue={serviceType?.duration_minutes || 30}
          required
        />
      </FormField>

      <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
        <Button type="submit" isLoading={isLoading} className="sm:col-start-2">
          {serviceType ? 'Salvar' : 'Criar'}
        </Button>
        <Button type="button" variant="secondary" onClick={onClose} className="sm:col-start-1">
          Cancelar
        </Button>
      </div>
    </Form>
  );
}

export default ServiceTypeForm;
